<template>
  <dashboard-template>
    <template slot="dashboard-body">
      <div v-if="!isLoading">
        <alerts-modal :alertsData="project.alerts" :sourcesData="project.sources"></alerts-modal>
        <div class="project-show-row d-flex w-100">
          <div class="project-show-cell">
            <div class="dashboard-header">
              <h6 class="mb-0">{{ $t('projects.updates_notifications') }}</h6>
              <img class="tooltip-icon icon-small mr-3" id="tooltip-project-updates" v-bind:src="'/app/images/icons/info.svg'" />
              <b-popover target="tooltip-project-updates" variant="warning" triggers="hover" placement="bottomleft">
                <div v-html="$t('tooltips.project_updates')"></div>
              </b-popover>
            </div>
            <div class="dashboard-content project-show-container-top">
              <div class="d-flex justify-content-between">
                <p class="mb-4">{{ $t('projects.next_update') }}</p>
                <p class="mb-4"><span>{{ nextUpdateDate | moment('D MMMM YYYY HH:mm') }}</span></p>
              </div>
              <div class="d-flex justify-content-between">
                <p>{{ $t('projects.update_frequency') }}</p>
                <p>{{ $t('projects.project_show_update_frequency') }}</p>
              </div>
              <div class="pb-1 my-4">
                <button type="button" class="btn btn-large btn-orange" @click="updateProjectFeeds(project.id)">
                  <refresh-cw-icon></refresh-cw-icon>
                  <span>{{ $t('projects.project_show_update_now') }}</span>
                </button>
              </div>
              <hr>
              <alert-type-info :name="$t('global.project')" :data="project.alerts.project"></alert-type-info>
              <alert-type-info :name="$t('global.sources')" :data="project.alerts.source"></alert-type-info>
              <alert-type-info :name="$t('global.feeds')" :data="project.alerts.feed"></alert-type-info>
              <div class="pt-1 mt-2">
                <button type="button" class="btn btn-large btn-orange-dark" @click="$bvModal.show('alertsModal')">
                  <info-icon></info-icon>
                  <span>{{ $t('projects.project_show_find_out_more') }}</span>
                </button>
              </div>
            </div>
          </div>
          <div class="project-show-cell">
            <div class="dashboard-header">
              <h6 class="mb-0">{{ $t('projects.project_show_feeds_statistics') }}</h6>
              <img class="tooltip-icon icon-small mr-3" id="tooltip-project-stats" v-bind:src="'/app/images/icons/info.svg'" />
              <b-popover target="tooltip-project-stats" variant="warning" triggers="hover" placement="bottomleft">
                <div v-html="$t('tooltips.project_stats')"></div>
              </b-popover>
            </div>
            <div class="dashboard-content project-show-container-top">
              <div class="project-show-feed-stats-container" v-if="project.feeds !== undefined && project.feeds.length > 0">
                <div class="project-show-feed-stats">
                  <p>
                    <span>{{ $t('projects.project_show_feed_count_products') }}</span>
                    <span class="text-orange" v-if="this.selectedFeed.logs.length > 0">{{ this.selectedFeed.logs[0].productCount }} (<span v-if="this.selectedFeed.logs[0].change > 0">+</span>{{ this.selectedFeed.logs[0].change }})</span>
                    <span class="text-orange" v-else>{{ $t('global.no_data') }}</span>
                  </p>
                  <div>
                    <multiselect
                      @select="onFeedSelect"
                      v-model="selectedFeed"
                      track-by="id"
                      label="name"
                      :placeholder="''"
                      :options="project.feeds"
                      :searchable="false"
                      :multiple="false"
                      :selected-label="''"
                      :select-label="''"
                      :deselect-label="''"
                      :allow-empty="false">
                      <template slot="option" slot-scope="props">
                        <span class="option__title">{{ props.option.name }}</span>
                      </template>
                    </multiselect>
                  </div>
                </div>
                <div v-if="selectedFeed.logData !== undefined && selectedFeed.chartOptions !== undefined" style="width: 100%;">
                  <line-chart :chart-data="selectedFeed.logData" :options="selectedFeed.chartOptions" :height="340"></line-chart>
                </div>
                <div v-else>{{ $t('global.loading') }}</div>
              </div>
              <div v-else class="alert alert-danger mb-4" role="alert">
                {{ $t('feeds.no_feeds') }}
              </div>
            </div>
          </div>
        </div>
        <div class="project-show-row d-flex w-100">
          <div class="project-show-cell">
            <div class="dashboard-header">
              <router-link :to="{ name: 'sources', params: { id: $route.params.id }}">
                <h6 class="mb-0">{{ $t('projects.project_show_sources') }}</h6>
              </router-link>
              <img class="tooltip-icon icon-small mr-3" id="tooltip-project-sources" v-bind:src="'/app/images/icons/info.svg'" />
              <b-popover target="tooltip-project-sources" variant="warning" triggers="hover" placement="bottomleft">
                <div v-html="$t('tooltips.project_sources')"></div>
              </b-popover>
            </div>
            <div class="dashboard-content project-show-container-bottom">
              <div v-if="project.sources !== undefined && activeSources.length > 0" class="pt-3">
                <div v-for="source in activeSources" v-bind:key="source.id" class="d-flex mb-5 pb-3">
                  <div class="project-show-source-cell1 d-flex align-items-center">
                    <img class="icon" v-bind:src="'/app/images/icons/sources/'+source.config.fileType+'.svg'" />
                    <div class="d-flex flex-column">
                      <p v-bind:class="'mb-0 mr-2 source-name source-'+source.config.fileType"><strong>{{ source.name }}</strong></p>
                      <div v-if="source.config.fileType !== 'analytics'">
                        <div v-if="source.config.fileType === 'docs'" class="d-flex">
                          <a v-if="source.config.docsConfig !== undefined" v-bind:href="'https://docs.google.com/spreadsheets/d/'+source.config.docsConfig.docsKey" target="_blank" class="mr-4 pr-3">
                            <u>Link</u>
                          </a>
                        </div>
                        <div v-else class="d-flex mr-4">
                          <div class="d-flex cursor-pointer">
                            <a v-bind:href="source.config.url" target="_blank" class="mr-4 pr-3">
                              <u>Link</u>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="project-show-source-cell2 d-flex">
                    <div v-if="source.config.fileType !== 'analytics'">
                      <div v-if="source.config.fileType === 'docs'" class="d-flex">
                        <div :id="'copy-feed-url-'+source.id" class="d-flex align-items-center mb-0 cursor-pointer copy-link-container" v-clipboard:copy="'https://docs.google.com/spreadsheets/d/'+source.config.docsConfig.docsKey" v-clipboard:success="onCopy('copy-feed-url-'+source.id)">
                          <copy-icon></copy-icon>
                          <p class="mb-1 ml-2">{{ $t('feeds.copy_link') }}</p>
                        </div>
                        <b-popover :target="'copy-feed-url-'+source.id" variant="success" triggers="click" placement="bottomleft">
                          <div>
                            <p class="mb-0">{{ $t('feeds.url_copied_to_clipboard') }}</p>
                          </div>
                        </b-popover>
                      </div>
                      <div v-else class="d-flex">
                        <div :id="'copy-feed-url-'+source.id" class="d-flex align-items-center mb-0 cursor-pointer copy-link-container" v-clipboard:copy="source.config.url" v-clipboard:success="onCopy('copy-feed-url-'+source.id)">
                          <copy-icon></copy-icon>
                          <p class="ml-2 mb-1">{{ $t('feeds.copy_link') }}</p>
                        </div>
                        <b-popover :target="'copy-feed-url-'+source.id" variant="success" triggers="click" placement="bottomleft">
                          <div>
                            <p class="mb-0">{{ $t('feeds.url_copied_to_clipboard') }}</p>
                          </div>
                        </b-popover>
                      </div>
                    </div>
                    <div v-else>
                      <strong>{{ source.config.analyticsConfig.profileId }}</strong>
                    </div>
                    <div class="mt-2">
                      <router-link :to="{ name: 'source.show', params: { projectId: project.id, sourceId: source.id }}">
                        <div class="d-flex mb-0 align-items-center">
                          <eye-icon></eye-icon>
                          <p class="ml-2 mb-2">{{ $t('global.details') }}</p>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div class="project-show-source-cell3 d-flex justify-content-center source-status">
                    <img v-if="source.config.primary" id="mainSourceFileIcon" class="icon mr-0 align-self-center" src="/app/images/icons/primary.png" />
                    <b-tooltip target="mainSourceFileIcon" triggers="hover">{{ $t('sources.main_file') }}</b-tooltip>
                  </div>
                  <div class="project-show-source-cell4 d-flex align-items-center justify-content-end">
                    <img v-if="hasSourceAlerts(source.id)" class="icon" src="/app/images/icons/error.svg" />
                    <img v-else class="icon" src="/app/images/icons/success.svg" />
                    <div>
                      <p class="text-lowercase mb-2"><strong>{{ source.lastProductCount }} {{ $t('global.products') }}</strong></p>
                      <p class="mb-0">{{ countHoursAgo(source.lastUpdate, new Date()) }} {{ $t('global.hours_ago') }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="alert alert-danger mb-4 mt-3" role="alert">
                {{ $t('sources.no_files') }}
              </div>
              <router-link :to="{ name: 'source.create', params: { projectId: this.project.id }}">
                <button type="button" class="btn btn-large btn-orange">
                  <plus-circle-icon></plus-circle-icon>
                  <span>{{ $t('projects.project_show_add_source') }}</span>
                </button>
              </router-link>
            </div>
          </div>
          <div class="project-show-cell">
            <div class="dashboard-header">
              <router-link :to="{ name: 'feeds', params: { id: $route.params.id }}">
                <h6 class="mb-0">{{ $t('projects.project_show_feeds') }}</h6>
              </router-link>
              <img class="tooltip-icon icon-small mr-3" id="tooltip-project-feeds" v-bind:src="'/app/images/icons/info.svg'" />
              <b-popover target="tooltip-project-feeds" variant="warning" triggers="hover" placement="bottomleft">
                <div v-html="$t('tooltips.project_feeds')"></div>
              </b-popover>
            </div>
            <div class="dashboard-content project-show-container-bottom">
              <div v-if="project.feeds !== undefined && project.feeds.length > 0" class="pt-3">
                <div v-for="feed in project.feeds" v-bind:key="feed.id" class="d-flex align-items-center mb-5 pb-3">
                  <div class="d-flex project-show-feeds-cell1">
                    <img class="icon-small" v-bind:src="matchFeedTemplateIcon(feed.feedType)" />
                    <div class="d-flex flex-column">
                      <router-link :to="{ name: 'feed.details', params: { id: project.id, feedId: feed.id }}" class="mb-0 mx-3">
                        <strong>{{ feed.name }}</strong>
                      </router-link>
                      <a class="mx-3" :href="feedsDirectoryUrl + feed.id+'.'+feed.config.resultType" target="_blank"><u>Link</u></a>
                    </div>
                  </div>
                  <div class="d-flex flex-column project-show-feeds-cell2">
                    <div :id="'copy-feed-url-'+feed.id" class="d-flex align-items-center mb-0 cursor-pointer copy-link-container" v-clipboard:copy="feedsDirectoryUrl + feed.id+'.'+feed.config.resultType" v-clipboard:success="onCopy('copy-feed-url-'+feed.id)">
                      <copy-icon></copy-icon>
                      <p class="ml-2 mb-1">{{ $t('feeds.copy_link') }}</p>
                    </div>
                    <b-popover :target="'copy-feed-url-'+feed.id" variant="success" triggers="click" placement="bottomleft">
                      <div>
                        <p class="mb-0">{{ $t('feeds.url_copied_to_clipboard') }}</p>
                      </div>
                    </b-popover>
                    <div class="mt-2">
                      <router-link :to="{ name: 'feed.details', params: { id: project.id, feedId: feed.id }}">
                        <div class="d-flex mb-0 align-items-center">
                          <eye-icon></eye-icon>
                          <p class="ml-2 mb-2">{{ $t('global.details') }}</p>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-end mr-4 project-show-feeds-cell3">
                    <div v-if="hasFeedAlerts(feed.id)">
                      <b-popover :target="'tooltip-feed-alerts'+feed.id" variant="danger" triggers="hover" placement="bottomleft">
                        <div>
                          <p class="mb-0">{{ project.alerts.feed.filter(alert => alert.feedId === feed.id)[0].message }}</p>
                        </div>
                      </b-popover>
                      <router-link :to="{ name: 'feed.details', params: { id: project.id, feedId: feed.id }}">
                        <img v-if="project.alerts.feed.filter(alert => alert.feedId === feed.id).filter(alert => alert.level === 0).length > 0" class="icon cursor-pointer" :id="'tooltip-feed-alerts'+feed.id" src="/app/images/icons/warning_danger.svg" />
                        <img v-else class="icon cursor-pointer" :id="'tooltip-feed-alerts'+feed.id" src="/app/images/icons/warning.svg" />
                      </router-link>
                    </div>
                    <div v-else>
                      <router-link :to="{ name: 'feed.details', params: { id: project.id, feedId: feed.id }}">
                        <img class="icon" src="/app/images/icons/success.svg" />
                      </router-link>
                    </div>
                    <div v-if="feed.logs.length > 0">
                      <p class="mb-2 text-lowercase"><strong>{{ feed.logs[0].productCount }} {{ $t('global.products') }}</strong></p>
                      <p class="mb-1">{{ countHoursAgo(feed.logs[0].date, new Date()) }} {{ $t('global.hours_ago') }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="alert alert-danger mb-4 mt-3" role="alert">
                {{ $t('feeds.no_feeds2') }}
              </div>
              <router-link :to="{ name: 'feed.create.main-settings', params: { projectId: this.project.id, feed: { name: '' } }}" v-bind:class="{ 'disabled-router-link': $attrs.project.products.length === 0 }">
                <button :disabled="$attrs.project.products.length === 0" type="button" class="btn btn-large btn-orange">
                  <plus-circle-icon></plus-circle-icon>
                  <span>{{ $t('projects.project_show_create_feed') }}</span>
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="spinner-border text-orange" role="status"></div>
      </div>
      <help></help>
    </template>
  </dashboard-template>
</template>

<script>
import Multiselect from 'vue-multiselect'
import DashboardTemplate from '@/views/Dashboard'
import dates from '@/mixins/dates'
import AlertsModal from './Partials/AlertsModal'
import AlertTypeInfo from './Partials/Alert/AlertTypeInfo'
import LineChart from './Partials/LineChart'
import { CopyIcon, EyeIcon, InfoIcon, PlusCircleIcon, RefreshCwIcon } from 'vue-feather-icons'
import axios from 'axios'
import Help from '@/components/Help'

export default {
  name: 'ProjectShow',

  data () {
    return {
      feedsDirectoryUrl: process.env.VUE_APP_FEEDS_DIRECTORY,
      feedTemplates: [],
      isLoading: true,
      project: {
        alerts: {},
        feeds: [],
        sources: []
      },
      selectedFeed: {}
    }
  },

  props: {
    projects: { required: true, type: Array }
  },

  mixins: [dates],

  created () {
    this.$moment().locale(this.$cookies.get('language_version'))
    this.project = this.projects.find(project => project.id === Number(this.$route.params.id))
    if (this.project.feeds.length > 0) {
      this.selectedFeed = this.project.feeds[0]
      this.prepareChartData()
      this.getFeedTemplates()
    } else {
      this.isLoading = false
    }
  },

  methods: {
    getFeedTemplates () {
      axios.get(process.env.VUE_APP_API_ENDPOINT + '/feed/templates/')
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.feedTemplates = response.data
            this.isLoading = false
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$router.push({ name: 'auth.error', params: { errorCode: error.response.data.statusCode, errorMessage: error.response.data.message } })
          }
        })
    },

    matchFeedTemplateIcon (feedTemplateName) {
      return this.feedTemplates.filter(template => template.name === feedTemplateName)[0].imageUrl
    },

    hasSourceAlerts (sourceId) {
      let result = false
      this.project.alerts.source.forEach(function (alert) {
        if (alert.sourceId === sourceId) result = true
      })
      return result
    },

    hasFeedAlerts (feedId) {
      let result = false
      this.project.alerts.feed.forEach(function (alert) {
        if (alert.feedId === feedId) result = true
      })
      return result
    },

    updateProjectFeeds () {
      this.$bvToast.toast(this.$t('feeds.feeds_updating_description'), {
        autoHideDelay: 3000,
        solid: true,
        title: this.$t('feeds.feeds_updating'),
        variant: 'info'
      })

      axios.get(process.env.VUE_APP_API_ENDPOINT + '/feed/update/' + this.$route.params.id)
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            window.dataLayer.push({ event: 'runFeedsUpdate' })
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$router.push({ name: 'auth.error', params: { errorCode: error.response.data.statusCode, errorMessage: error.response.data.message } })
          }
        })
    },

    onFeedSelect (value) {
      this.selectedFeed = value
      this.prepareChartData()
    },

    prepareChartData () {
      const logs = this.selectedFeed.logs
      const labels = logs.slice(0, 7).map(function (log) { return log.date.substr(0, 10) })
      const values = logs.slice(0, 7).map(function (log) { return log.productCount })
      this.selectedFeed.logData = {
        labels: labels.reverse(),
        datasets: [
          {
            label: this.$t('feeds.feed_product_count'),
            backgroundColor: '#fbaf3d',
            data: values.reverse()
          }
        ]
      }

      this.selectedFeed.chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 500
            }
          }]
        }
      }
    },

    onCopy (popoverId) {
      setTimeout(function () {
        this.$root.$emit('bv::hide::popover', popoverId)
      }.bind(this), 1500)
    }
  },

  computed: {
    nextUpdateDate: function () {
      if (this.project.sources[0] !== undefined) return this.$moment(this.project.sources[0].lastUpdate).add(1, 'days')
      else return new Date()
    },

    lastProductCountSum () {
      return Number(this.project.sources.reduce((pv, cv) => Number(pv) + Number(cv.lastProductCount), 0))
    },

    isAnyAlert () {
      if ((this.project.alerts.feed.length > 0) || (this.project.alerts.project.length > 0) || (this.project.alerts.source.length > 0)) return true
      else return false
    },

    projectAlertsCount () {
      return this.project.alerts.project.length
    },

    sourceAlertsCount () {
      return this.project.alerts.source.length
    },

    feedAlertsCount () {
      return this.project.alerts.feed.length
    },

    sortedAlertTypes () {
      return Object.keys(this.project.alerts).sort().reduce((obj, key) => {
        obj[key] = this.project.alerts[key]
        return obj
      }, {})
    },

    activeSources () {
      return this.project.sources.filter(source => source.active === true)
    }
  },

  components: { AlertsModal, AlertTypeInfo, CopyIcon, DashboardTemplate, EyeIcon, Help, InfoIcon, LineChart, Multiselect, PlusCircleIcon, RefreshCwIcon }
}
</script>
